import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select } from '@ngxs/store';
import { AuthState, LoggedIn } from 'common/store/auth/auth.state';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { environment } from 'common/environments/environment';
import { AppConstants, EnvName } from 'common/app-constants';

@Component({
    selector: 'app-connected-portal-redirect',
    templateUrl: './connected-portal-redirect.component.html',
    styleUrls: ['./connected-portal-redirect.component.scss']
})

export class ConnectedPortalRedirectComponent implements OnInit {
  @Select(AuthState.loggedIn) loggedIn$: Observable<LoggedIn>;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
      this.loggedIn$.pipe(
          filter((loggedIn) => loggedIn !== LoggedIn.Unknown),
          take(1)
      ).subscribe((loggedIn) => {
          if (loggedIn === LoggedIn.LoggedIn) {
              this.redirectToConnectedPortal();
          }
      // If not logged in, the Auth guard will handle the redirect to login
      });
  }

  private redirectToConnectedPortal(): void {
      const queryParams = this.route.snapshot.queryParams;

      let cpUrl = AppConstants.LOCAL_CP_URL;

      switch (environment.envName) {
          case EnvName.Dev:
              cpUrl = AppConstants.DEV_CP_URL;
              break;
          case EnvName.Staging:
              cpUrl = AppConstants.STG_CP_URL;
              break;
          case EnvName.Production:
              cpUrl = AppConstants.PRD_CP_URL;
              break;
          default:
              break;
      }

      const urlParams = new URLSearchParams();
      Object.keys(queryParams).forEach((key) => {
          if (key !== 'path') {
              urlParams.append(key, queryParams[key]);
          }
      });

      if (urlParams.toString()) {
          cpUrl += `?${urlParams.toString()}`;
      }

      window.location.href = cpUrl;
  }
}
